import { render } from "./ShelterFloatButton.vue?vue&type=template&id=81f9c286&scoped=true"
import script from "./ShelterFloatButton.vue?vue&type=script&lang=js"
export * from "./ShelterFloatButton.vue?vue&type=script&lang=js"

import "./ShelterFloatButton.vue?vue&type=style&index=0&id=81f9c286&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81f9c286"]])

export default __exports__